import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const SalesTargetService = {
  getAll: async () => {
    const res = await axios.get(ENDPOINT.SalesTargets);
    return res.data;
  },
  getById: async (id) => {
    const res = await axios.get(`${ENDPOINT.SalesTargets}/${id}`);
    return res.data;
  },
  create: async (data) => {
    const res = await axios.post(ENDPOINT.SalesTargets, data);
    return res.data;
  },
  update: async (id, data) => {
    const res = await axios.put(`${ENDPOINT.SalesTargets}/${id}`, data);
    return res.data;    
  },
  remove: async (id) => {
    const res = await axios.delete(`${ENDPOINT.SalesTargets}/${id}`);
    return res.data;
  },
};